export default __webpack_public_path__ + "static/media/feedback-lowlights.6cae0994.svg";